import React from "react";
import DotAnimation from "../DotAnimation/DotAnimation";
import "./Hero.css";

const Hero: React.FC = () => {
  return (
    <section id="hero" className="hero-section">
      <DotAnimation />
      <div className="hero-content">
        <p id="logo">Momentup</p>
        <h2 className="hero-title">
          당신의 이야기에 압도적인 가속도를 더합니다.
        </h2>
        <p className="hero-subtitle">
          혼자라면 멈췄을 당신의 이야기, <br /> 성공의 궤도에 올려놓겠습니다.
        </p>
      </div>
    </section>
  );
};

export default Hero;
